import React from 'react'
import Layout from 'templates/ModuleTemplate'
import ModuleGuard from 'components/ModuleGuard'

const CorbanLayout: React.FC = ({ children }) => {
  return (
    <Layout>
      <ModuleGuard>{children}</ModuleGuard>
    </Layout>
  )
}

export default CorbanLayout
